<template>
  <div class="standard-notes">
    <ul class="notes-list">
      <li>※送付後、一定期間内に連絡がない場合、確認済みとします。</li>
      <li>※今回のお支払いは確定申告の際「{{fiscalYear}}年分」の収入金額となります。</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'StandardNotes',
  props: {
    fiscalYear: {
      type: String,
      default: '0'
    }
  }
};
</script>

<style scoped>
.standard-notes {
  margin: 20px 0;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.notes-list {
  padding-left: 20px;
  margin: 0;
  color: #666;
}

.notes-list li {
  margin-bottom: 5px;
}

.notes-list li:last-child {
  margin-bottom: 0;
}
</style> 